import { render, staticRenderFns } from "./NoEmailAddressWarning.vue?vue&type=template&id=1a0939df&scoped=true"
import script from "./NoEmailAddressWarning.vue?vue&type=script&lang=js"
export * from "./NoEmailAddressWarning.vue?vue&type=script&lang=js"
import style0 from "./NoEmailAddressWarning.vue?vue&type=style&index=0&id=1a0939df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0939df",
  null
  
)

export default component.exports